import { FC } from 'react';
import { useNavigate } from 'react-router';
import { Icon } from '@fuxi/eevee-ui';
import { UserCertifyType } from 'common/constants';
import { MyInfoRouterParams, ROUTER_PATHNAME } from 'common/router/config';
import NotCertificationHomeSvg from 'common/assets/icon/not-certification-home.svg';
import PersonalCertificationHomeSvg from 'common/assets/icon/personal-certification-home.svg';
import CompanyCertificationHomeSvg from 'common/assets/icon/company-certification-home.svg';

import cx from './RealNameCertifyTag.module.css';

const CertifyLabelTextColor = {
  [UserCertifyType.UnCertified]: 'var(--color-text-secondary)',
  [UserCertifyType.PersonalCertified]: 'rgba(8, 199, 192, 1)',
  [UserCertifyType.EnterpriseCertified]: 'var(--orange-6)',
};

const CertifyLabelText = {
  [UserCertifyType.UnCertified]: '未实名',
  [UserCertifyType.PersonalCertified]: '个人实名',
  [UserCertifyType.EnterpriseCertified]: '企业实名',
};

const CertifyLabelBgColor = {
  [UserCertifyType.UnCertified]: 'var(--color-primary-bg)',
  [UserCertifyType.PersonalCertified]: 'var(--color-success-bg)',
  [UserCertifyType.EnterpriseCertified]: 'var(--color-warning-bg)',
};

const CertifyLabelIcon = {
  [UserCertifyType.UnCertified]: <img src={NotCertificationHomeSvg} alt="" />,
  [UserCertifyType.PersonalCertified]: <img src={PersonalCertificationHomeSvg} alt="" />,
  [UserCertifyType.EnterpriseCertified]: <img src={CompanyCertificationHomeSvg} alt="" />,
};

type RealNameCertifyTagProps = { userCertifyType: UserCertifyType; isMe?: boolean };

export const RealNameCertifyTag: FC<RealNameCertifyTagProps> = ({ userCertifyType, isMe }) => {
  const navigate = useNavigate();

  const handleCertifyClick = () => {
    isMe &&
      userCertifyType === UserCertifyType.UnCertified &&
      navigate(`/${ROUTER_PATHNAME.USER_PREFERENCE}/${MyInfoRouterParams.activeTab.realNameAuth}`);
  };

  return (
    <div
      onClick={handleCertifyClick}
      className={cx('artist-certify-label')}
      style={{
        color: CertifyLabelTextColor[userCertifyType!],
        backgroundColor: CertifyLabelBgColor[userCertifyType!],
      }}>
      {CertifyLabelIcon[userCertifyType!]}
      {CertifyLabelText[userCertifyType!]}
      {isMe && userCertifyType === UserCertifyType.UnCertified && <Icon name="Next" size={16} />}
    </div>
  );
};
